// eslint-disable-next-line import/prefer-default-export
export const GET_KPIS = 'GET_KPIS';
export const GET_EMPLOYEES_ASSIGNED_KPIS = 'GET_EMPLOYEES_ASSIGNED_KPIS';
